import { graphql } from '@/gql';
import type { SearchGroceryAvailableStoresAndSendEmailQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { GroceryStore } from '@/models/grocery';

export const searchGroceryAvailableStoresAndSendEmail = async ({
  streetAddress,
  city,
  state,
  zip,
  latitude,
  longitude,
  country,
  emailAddress,
}: SearchGroceryAvailableStoresAndSendEmailQueryVariables): Promise<GroceryStore[]> => {
  const response = await queryExecute({
    query: graphql(`
      query SearchGroceryAvailableStoresAndSendEmail(
        $streetAddress: String!
        $city: String!
        $state: String!
        $zip: String!
        $latitude: Float!
        $longitude: Float!
        $country: String!
        $emailAddress: String
      ) {
        searchGroceryAvailableStoresAndSendEmail(
          streetAddress: $streetAddress
          city: $city
          state: $state
          zip: $zip
          latitude: $latitude
          longitude: $longitude
          country: $country
          emailAddress: $emailAddress
        ) {
          id
          name
          slug
          description
          logo
          serviceTypeBadges {
            label
            color
            accessibleColor
          }
          statusBadges {
            label
            color
            accessibleColor
          }
        }
      }
    `),
    variables: {
      streetAddress,
      city,
      state,
      zip,
      latitude,
      longitude,
      country,
      emailAddress,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.searchGroceryAvailableStoresAndSendEmail;
};
